<script setup lang="ts">
const { metaTitle, pageTitle, pageDescription } = usePageTranslation()

useHead({
	title: metaTitle,
})
</script>

<template>
	<main class="relative flex min-h-screen flex-col items-center justify-center gap-6 bg-gray-50 pt-0">
		<router-link :href="route('dashboard')">
			<logo />
		</router-link>

		<ui-card :class="cn('sm:max-w-md w-full rounded-none sm:rounded-xl', $attrs.class ?? '')">
			<ui-card-header :class="cn('text-center', $attrs.class ?? '')">
				<ui-card-title>{{ pageTitle }}</ui-card-title>
				<ui-card-description>{{ pageDescription }}</ui-card-description>
			</ui-card-header>

			<slot />
		</ui-card>
	</main>
</template>
